import { useAtomValue } from 'jotai'
import { externalCanvasDataAtom } from '../atoms'
import { useCanvasStore } from '../canvas-store'
import type { ExternalCanvasData } from '../container'
import type { TextColor } from '../data/v1'

/**
 * An unset colour resolves to undefined rather than an empty string, so a caller's `??` fallback
 * catches it. Documents are also written outside the editor (see `data/canvas-schema.json`), where
 * a literal colour can arrive empty.
 */
export function resolveColor(color: TextColor, externalData: ExternalCanvasData): string | undefined {
	switch (color.mode) {
		case 'foregroundColor':
			return externalData.foregroundColor || undefined
		case 'backgroundColor':
			return externalData.backgroundColor || undefined
		case 'accentForegroundColor':
			return externalData.accentForegroundColor || undefined
		case 'accentBackgroundColor':
			return externalData.accentBackgroundColor || undefined
		case 'color':
			return color.color || undefined
	}
}

export function useResolvedColor(color: TextColor): string | undefined {
	const store = useCanvasStore()
	const externalData = useAtomValue(externalCanvasDataAtom, { store })

	return resolveColor(color, externalData)
}
